const elements = [...document.querySelectorAll('.js-data-fade-in-on-top')];

const visited = localStorage.getItem('RSC_VISITED');
if(!visited) {
  setTimeout(() => {
    elements.forEach((el) => {
      el.classList.add('is-active', 'transition');
    });
  }, 4000);
}
else {
  elements.forEach((el) => {
    el.classList.add('is-active');
  });
}
